<div class="dialog">

    <div class="modal-header">
        <h2 class="modal-title">View EOD Report</h2>
        <img src="assets/images/close.svg" alt="" class="close close-dialog" mat-dialog-close>
    </div>

    <div class="dialog-content">


        <div class="row pt-2">
            <div class="col-md-8">
                <div class="date-all" style="font-weight: bolder;">
                    Date: <span style="font-size: 15px; font-weight: 100 !important;">{{eodDateTime}}</span>
                </div>
            </div>
            <div class="col-md-4" style="padding-left: 35px;">
                <button class="prim-link " style=" width: 90px; font-size: 11px !important;"
                    (click)="showEodReportConfig()">
                    <img src="../../../../assets/images/wow-gears-icon-selected.svg"
                        style="margin-right:3px; width: 20px;" alt="setting">EOD Alert
                </button>
            </div>
            <div class="table-data mt-2">
                <table aria-describedby="" class="table table-bordered table-style">
                    <thead>
                        <tr>
                            <th scope="col" style="width: 90%;"><strong>Task Name</strong> </th>
                            <th scope="col"><strong>Status</strong> </th>
                        </tr>
                    </thead>
                    <tbody class="table-bordered">
                        <tr (click)="handleOpen('procedure')" style="cursor: pointer;">
                            <td style="width: 90%;"><strong>All procedure completed</strong></td>
                            <td colspan="1">
                                <img [src]="status?.procedure?.remaining==0 ? green :  red" class="icon-tick"
                                    alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('procedure')">
                            <td colspan="2">
                                <p>
                                    <strong>{{status?.procedure?.remaining}}</strong>
                                    procedure(s) not completed.
                                </p>
                            </td>
                        </tr>

                        <tr (click)="handleOpen('order')" style="cursor: pointer;">
                            <td style="width: 90%;"><strong>All orders for tomorrow are placed</strong></td>
                            <td colspan="1">
                                <img [src]="status?.order?.offline?.remaining==0 && status?.order?.online?.remaining==0 ? green :  red"
                                    class="icon-tick" alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('order')">
                            <td colspan="2">
                                <div class=" m_t5 m_b10" *ngIf="status?.order?.online?.remaining">
                                    <strong>{{status?.order?.online?.remaining}}</strong> online order(s) not sent.
                                </div>
                                <div class=" m_t5 m_b10" *ngIf="status?.order?.offline?.remaining">
                                    <strong>{{status?.order?.offline?.remaining}}</strong> offline order(s) not placed.
                                </div>
                            </td>
                        </tr>

                        <tr (click)="handleOpen('inventory')" style="cursor: pointer;">
                            <td style="width: 90%;">
                                <strong>All expired inventory wasted</strong>
                            </td>
                            <td colspan="1">
                                <img [src]="status?.inventory?.remaining==0 ? green :  red" class="icon-tick"
                                    alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('inventory')">
                            <td colspan="2">
                                <p><strong>{{status?.inventory?.remaining}}</strong> expired
                                    radioactive inventory item(s) not moved to waste bin/return boxes.</p>
                            </td>
                        </tr>

                        <tr (click)="handleOpen('waste')" style="cursor: pointer;">
                            <td style="width: 90%;">
                                <strong>All RFD return boxes marked returned</strong>
                            </td>
                            <td colspan="1">
                                <img [src]="status?.waste?.remaining==0 ? green :  red" class="icon-tick" alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('waste')">
                            <td colspan="2">
                                <p>
                                    <strong>{{status?.waste?.remaining}}</strong> ready for
                                    disposal return box(es) not marked as returned.
                                </p>
                            </td>
                        </tr>

                        <tr (click)="handleOpen('task')" style="cursor: pointer;">
                            <td style="width: 90%;">
                                <strong> All scheduled tasks completed </strong>
                            </td>
                            <td colspan="1">
                                <img [src]="status?.task?.remaining==0 ? green :  red" class="icon-tick" alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('task')">
                            <td colspan="2">
                                <p>
                                    <strong>{{status?.task?.remaining}}</strong> task(s) not completed.
                                </p>
                            </td>
                        </tr>



                        <tr (click)="handleOpen('personnel')" style="cursor: pointer;">
                            <td style="width: 90%; cursor: pointer;">
                                <strong>All personnel surveys completed </strong>
                            </td>
                            <td colspan="1">
                                <img [src]="status?.personnel?.personnelSurveyCompleteFlagForEodReport==true ? green :  red"
                                    class="icon-tick" alt="icon">
                            </td>
                        </tr>
                        <tr class="grey" [hidden]="!isOpen('personnel')">
                            <td colspan="2">
                                <p>
                                    <strong>{{status?.personnel?.remaining}}</strong> Personnel Survey(s) not completed
                                    for
                                </p>
                                <span *ngFor="let person of status?.personnel?.data">
                                    <strong>{{person.name}} ; &nbsp;</strong>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div [hidden]="!message" class="error_format_eod">{{message}}</div>


            <div class="date-time mx-3">
                <label style="font-weight: bolder;">
                    Sign Off Date & Time <span class="text-danger">*</span>
                </label>
                <div class="display_flx">
                    <div>
                        <table aria-describedby="" style="width: 50%;">
                            <tr class="hidden-header">
                                <th id="hidden-header1">
                                </th>
                            </tr>
                            <tr>
                                <td>
                                    <table aria-describedby="">
                                        <tr class="hidden-header">
                                            <th id="hidden-header2">
                                            </th>
                                        </tr>
                                        <tr
                                            style="border: 1px solid #ccc; height: 45px; padding: 5px; padding-left: 70px; width: 50%;">
                                            <span>
                                                <div class="datetime-input">
                                                    <img class="datepicker-toggle" alt="" (click)="dp.open()">
                                                    <input class="date-input" matInput dateInput [matDatepicker]="dp"
                                                        [readonly]="readOnly" [formControl]="date" maxlength="10"
                                                        placeholder="MM/DD/YYYY" />
                                                    <mat-datepicker #dp [disabled]="readOnly"></mat-datepicker>

                                                    <ngx-material-timepicker-toggle class="time-picker"
                                                        buttonAlign="left" style="margin-top: 5px;" [for]="tp"
                                                        [disabled]="readOnly">
                                                    </ngx-material-timepicker-toggle>
                                                    <input matInput timeInput [ngxTimepicker]="tp" maxlength="5"
                                                        [disableClick]="true" class="time-input" placeholder="HH:mm"
                                                        [format]="24" [value]="time.value" [formControl]="time"
                                                        (isValid)="isTimeValid=$event" [readonly]="readOnly">
                                                    <ngx-material-timepicker [appendToInput]="true" #tp
                                                        (timeChanged)="isTimeValid=true"
                                                        [timepickerClass]="'custom-timepicker'">
                                                    </ngx-material-timepicker>
                                                </div>
                                            </span>
                                        </tr>
                                    </table>

                                </td>


                            </tr>
                        </table>
                    </div>

                    <div class="pdng_lft_50">
                        <mat-checkbox style="float: right; padding-right: 25px; padding-top: 20px;" class="check-box"
                            [checked]="dailyReportChecked" (change)="dailyReport()">

                            <span class="rpt_lbl_txt">Daily Report</span>

                        </mat-checkbox>

                    </div>


                </div>


                <mat-error *ngIf="isDateTimeInvalid">Invalid SignOff Date or Time</mat-error>
                <mat-error *ngIf="isDateTimeRequired">SignOff Date & Time is required </mat-error>

            </div>

            <div class="mb-3 mt-2 mx-3">
                <label style="font-weight: bolder;">Note</label>

                <div class=" shipment_input_width" *ngIf="!readOnly">
                    <textarea class="form-control" rows="3" [(ngModel)]="note" style="font-size: 14px;"
                        placeholder="Enter sign off comments"></textarea>
                </div>
                <div class="shipment_input_width" *ngIf="readOnly">
                    <textarea class="form-control" rows="3" [(ngModel)]="note" disabled="disabled"
                        style="font-size: 14px;"></textarea>
                </div>

            </div>
            <div style="margin-left: 153px; margin-top: 5px;">
                <button class="signoff text-danger" (click)="save()">{{buttonName}}</button>
                <button class="canc" mat-dialog-close>CANCEL</button>
            </div>


        </div>



    </div>